export default "__VITE_ASSET__909cdca1__"